import { Logo } from "@/components/Logo";
import { usePageTitle } from "@/hooks/usePageTitle";

/** Shared centered auth layout with brand side. */
export function AuthLayout({ children, title, subtitle, hint }) {
  usePageTitle(title);
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden overflow-hidden bg-[#101876] p-10 text-white lg:flex lg:flex-col lg:justify-between">
        <div className="grain absolute inset-0" />
        <div className="relative">
          <Logo inverted />
        </div>
        <div className="relative max-w-lg">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-white/60">SIHMT · Steward Healthcare</div>
          <h2 className="mt-3 text-4xl font-black leading-tight" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>
            Enterprise healthcare<br />learning, delivered <span className="text-[#7ce561]">digitally.</span>
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-white/75">
            Compliance-ready modules, role-based dashboards, and audit-grade
            certification — engineered for hospitals, colleges and labs.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-6 text-white/85">
            {[
              ["500+", "Hospitals ready"],
              ["50k+", "Learners target"],
              ["NABH", "Aligned"],
            ].map(([k, v]) => (
              <div key={k}>
                <div className="text-2xl font-black">{k}</div>
                <div className="text-[10px] uppercase tracking-widest text-white/60">{v}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative text-xs text-white/60">
          © {new Date().getFullYear()} Steward Healthcare India Pvt. Ltd.
        </div>
      </div>
      <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4 py-10 sm:px-8">
        <div className="w-full max-w-md">
          <div className="mb-6 flex justify-center lg:hidden">
            <Logo />
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
            <h1 className="text-2xl font-black text-slate-900" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-slate-600">{subtitle}</p>}
            <div className="mt-6">{children}</div>
          </div>
          {hint && <div className="mt-4 text-center text-xs text-slate-500">{hint}</div>}
        </div>
      </div>
    </div>
  );
}
